import { useNav } from "@pomle/react-router-paths";
import {
  FALLBACK_LOCALE,
  Locale,
  language2Locale,
} from "render/context/InternationalizationContext";
import { PatientPhysicalIdentifier } from "render/fragments/patient/PatientPhysicalIdentifier";
import { usePatientQuery } from "render/hooks/api/queries/usePatientQuery";
import { paths } from "render/routes/paths";
import { Typography } from "render/ui/presentation/Typography";
import { InfoField } from "./components/InfoField/InfoField";
import styles from "./styles.module.sass";
import { Trans } from "./trans";

const getPreferredLanguage = (preferredLanguage: string | undefined) => {
  const supportedLanguages: Record<Locale, string> = {
    en_GB: "English",
    sv_SE: "Swedish",
  };

  const prefLang = language2Locale(preferredLanguage ?? "");
  return supportedLanguages[prefLang || FALLBACK_LOCALE] ?? "";
};

export function PatientInfo() {
  const patientQuery = usePatientQuery();

  const nav = {
    editEmail: useNav(paths.profileCredentialsEditEmail),
    editLanguage: useNav(paths.profileCredentialsEditLanguage),
    editName: useNav(paths.profileCredentialsEditName),
    editPhone: useNav(paths.profileCredentialsEditPhone),
  };

  if (!patientQuery.data) {
    return null;
  }

  const { name, contactDetails, preferredLanguage } = patientQuery.data;

  return (
    <ul className={styles.PatientInfo}>
      <li>
        <InfoField
          label={<Trans.Label.Name />}
          value={
            name?.displayName ??
            name?.firstName ?? (
              <Typography variant="cta">
                <Trans.PlaceHolder.AddName />
              </Typography>
            )
          }
          onClick={nav.editName.on({})}
        />
      </li>
      <li>
        <InfoField
          label={<Trans.Label.PersonalNumber />}
          value={<PatientPhysicalIdentifier patient={patientQuery.data} />}
        />
      </li>
      <li>
        <InfoField
          label={<Trans.Label.Cellphone />}
          value={
            contactDetails.phoneNumbers[0] ?? (
              <Typography variant="cta">
                <Trans.PlaceHolder.AddPhone />
              </Typography>
            )
          }
          onClick={nav.editPhone.on({})}
        />
      </li>
      <li>
        <InfoField
          label={<Trans.Label.Email />}
          value={
            contactDetails.email ?? (
              <Typography variant="cta">
                <Trans.PlaceHolder.AddEmail />
              </Typography>
            )
          }
          onClick={nav.editEmail.on({})}
        />
      </li>
      <li>
        <InfoField
          label={<Trans.Label.Language />}
          value={getPreferredLanguage(preferredLanguage || undefined)}
          onClick={nav.editLanguage.on({})}
        />
      </li>
    </ul>
  );
}
